import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloLink,
  from,
} from "@apollo/client";
import { store } from "../../redux/store";
import { onError } from "@apollo/client/link/error";

// Configuración de la URL base
const baseURL = process.env.REACT_APP_BASE_URL_GRAPHQL;

// console.log("GraphQL Endpoint:", baseURL);

// Middleware de autenticación
const authMiddleware = new ApolloLink((operation, forward) => {
  const { token } = store.getState().authReducer;
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : "",
    },
  });
  return forward(operation);
});

// Manejo de errores
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Configuración del cliente Apollo
export const client = new ApolloClient({
  link: from([errorLink, authMiddleware, new HttpLink({ uri: baseURL })]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    },
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});
